import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { ComplementsCreateDishSelectPage } from './complements-create-dish-select/complements-create-dish-select';
import { Globals } from '../../../globals';
import { ConfigurationServices } from '../../configuration/services';

@Component({
    selector: 'page-complements-partial-select',
    templateUrl: 'complements-partial-select.html',
})
export class ComplementsPartialSelectPage {
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public translate: TranslateService,
        public configurationServices: ConfigurationServices) {
    }

    ngOnInit(): void {
        this.configurationServices.getComplementsGroups();
    }

    createGroupComplements() {
        this.navCtrl.push(ComplementsCreateDishSelectPage, {
            update: false,
            section: {},
            section_index: null,
            uid: null
        });
    }

    clickElement(event) {
        if (event.type === 'click') {
            const selectedGroup = event.row;

            // Ensure the group is not already selected
            const exists = this.configurationServices.complements_groups_selected.find(group => group.UID === selectedGroup.UID);
            if (!exists) {
                this.configurationServices.complements_groups_selected.push({
                    ...selectedGroup,
                    pos_active: true,   // activate TPV by default
                    tk_active: false    // optional: keep TK unchecked
                });
            }
        }
    }

    onSort(event) {
        var variations_array = this.configurationServices.complements_group_array_filtered;

        switch (event.column.name) {
            case 'name':
                if (event.newValue == 'asc') {
                    variations_array.sort((a, b) => this.globals.nameNotEsLang(a).toLowerCase().localeCompare(this.globals.nameNotEsLang(b).toLowerCase()));
                } else {
                    variations_array.sort((a, b) => this.globals.nameNotEsLang(b).toLowerCase().localeCompare(this.globals.nameNotEsLang(a).toLowerCase()));
                }
                break;
            case 'price':
                if (event.newValue == 'asc') {
                    variations_array.sort((a, b) => a.price - b.price);
                } else {
                    variations_array.sort((a, b) => b.price - a.price);
                }
                break;
            case 'quantity':
                if (event.newValue == 'asc') {
                    variations_array.sort((a, b) => a.quantity.toLowerCase().localeCompare(b.quantity.toLowerCase()));
                } else {
                    variations_array.sort((a, b) => b.quantity.toLowerCase().localeCompare(a.quantity.toLowerCase()));
                }
                break;
            case 'type':
                if (event.newValue == 'asc') {
                    variations_array.sort((a, b) => a.type.localeCompare(b.type));
                } else {
                    variations_array.sort((a, b) => b.type.localeCompare(a.type));
                }
                break;
        }

        this.configurationServices.complements_group_array_filtered = variations_array;
    }
}



// WEBPACK FOOTER //
// ./src/pages/complements/complements-partial-select/complements-partial-select.ts